export const CloseIcon = ({
  width = 15,
  height = 16,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={ height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.97061 8.55635L17.0417 1.48528L15.6275 0.0710677L8.5564 7.14214L1.48533 0.0710677L0.0711153 1.48528L7.14218 8.55635L0.0711146 15.6274L1.48533 17.0416L8.5564 9.97056L15.6275 17.0416L17.0417 15.6274L9.97061 8.55635Z"
      fill="currentColor"
    />
  </svg>
);